import React from 'react';

import { Stack, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import MoreButtonCDS from '../Buttons/MoreButtonCDS';
import FunctionIcon, { FunctionIconSize } from '../FunctionIcon';
import { InfoIcon } from '../icons';

const InfoTitle = ({ title, icon = null, withMenu = false, className = '' }) => {
  return (
    <Stack className={clsx('justify-between', className)} direction="row">
      <Stack className="items-center gap-8" direction="row">
        <FunctionIcon iconSize={FunctionIconSize.SMALL}>
          {icon || <InfoIcon size={IconSize[16]} />}
        </FunctionIcon>
        <Typography variant="bold16">{title}</Typography>
      </Stack>
      {withMenu && <MoreButtonCDS disabled />}
    </Stack>
  );
};

InfoTitle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  withMenu: PropTypes.bool,
  className: PropTypes.string,
};

export default InfoTitle;
